import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import "./TopStories.css";

import React, { useEffect } from "react";

import AOS from "aos";
import { assest } from "../../assest/assest";

// Dummy data (images) for top stories
const topStories = [
  { id: 1, imageUrl: assest.ga1 },
  { id: 2, imageUrl: assest.ga2 },
  { id: 3, imageUrl: assest.ga3 },
  { id: 4, imageUrl: assest.ga4 },
  { id: 5, imageUrl: assest.ga5 },
  { id: 6, imageUrl: assest.ga6 },
  { id: 7, imageUrl: assest.ga8 },
  { id: 8, imageUrl: assest.ga9 },
  { id: 9, imageUrl: assest.ga10 },
  { id: 10, imageUrl: assest.ga11 },
  { id: 11, imageUrl: assest.ga12 },
  { id: 12, imageUrl: assest.ga13 },
  { id: 13, imageUrl: assest.ga14 },
  { id: 14, imageUrl: assest.ga15 },
  { id: 15, imageUrl: assest.ga16 },
  { id: 16, imageUrl: assest.ga17 },
  { id: 17, imageUrl: assest.ga18 },
  { id: 18, imageUrl: assest.ga7 },
];

const TopStories = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <div className="xx">
      <div className="memories-section py-5">
        <div className="container">
          <div className="text-center mb-4" data-aos="fade-up">
            <h2 className="memories-title">Memories</h2>
            <h4>-A Collection Of Unforgettable Moments-</h4>
          </div>

          {/* Image Gallery Grid */}
          <div className="row gallery-row">
            {topStories.length > 0 ? (
              topStories.map((story, index) => (
                <div
                  key={story.id}
                  className={`col-md-4 col-sm-6 mb-4 ${
                    index % 3 === 0 ? "large-card" : "small-card"
                  }`}
                  data-aos="fade-up"
                  data-aos-delay={index * 50}
                >
                  <div
                    id="memories"
                    className="gallery-image"
                    style={{ backgroundImage: `url(${story.imageUrl})` }}
                  ></div>
                </div>
              ))
            ) : (
              <p className="text-center text-white" data-aos="fade-up">
                No memories available.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopStories;
